import { MapLike } from '@iotv/iotv-v3-types'

type GetByDotVars = { currentOb: any; lastVal: any }
/** extracts by dot, lastVal is currently unnessasary but retained for likely future use */
export const getByDotKey = (key: string, object: object) => {
  const keyParts = key.split('.')

  const parsed = keyParts.reduce(
    (a, k) => {
      if (a.currentOb[k]) {
        a = { currentOb: a.currentOb[k], lastVal: a.currentOb[k] }
      } else {
        a = { currentOb: null, lastVal: null }
      }
      return a
    },
    { currentOb: object, lastVal: null } as GetByDotVars,
  )

  return parsed.lastVal
}
